import { useAuth } from "@/shared/hooks/useAuth";
import { isDemoUser } from "@/shared/lib/userIdUtils";

/** Returns true when the current user is a demo account — either by the
 *  canonical email (`demo@roboticimaging.com`) OR by Firebase UID in the
 *  DEMO_USER_UIDS allowlist (for client-branded demo accounts).
 *
 *  Subscribes to `useAuth` so it re-evaluates on sign-in/out; the actual
 *  determination is shared with the non-hook {@link isDemoUser} (single source
 *  of truth — used by plain services like projectsApi). */
export function useIsDemoUser(): boolean {
  useAuth(); // re-render on auth state change
  return isDemoUser();
}
